export enum BusinessSummaryRequestType {
  OWN_BUSINESSES,
  CLIENT_BUSINESSES,
  VENDOR_BUSINESSES,
  TOP_LEVEL_NUMBERS,
  INVOICE_GROUPS,
}
